// extracted by mini-css-extract-plugin
var _1 = "advantages__HrV24";
var _2 = "card__pvYOJ";
var _3 = "imageWrapper__DmHX3";
var _4 = "mainBlock__ZbFCi";
var _5 = "row__w4SlO";
var _6 = "subtitle__js0hU";
var _7 = "text__Vv4MH";
export { _1 as "advantages", _2 as "card", _3 as "imageWrapper", _4 as "mainBlock", _5 as "row", _6 as "subtitle", _7 as "text" }
export default { "advantages": _1, "card": _2, "imageWrapper": _3, "mainBlock": _4, "row": _5, "subtitle": _6, "text": _7 }
